import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, tap } from 'rxjs';
import { Permissions } from './permissions';

export function hasPermission(permission: string): CanActivateFn {
  return () => {
    const permissions = inject(Permissions);
    const router = inject(Router);
    return permissions.get$().pipe(
      map((granted) => permission === '' || granted.includes(permission)),
      tap((allowed) => {
        if (!allowed) {
          router.navigateByUrl('/not-found');
        }
      }),
    );
  };
}
